module.exports = __webpack_public_path__ + "static/img/周围血管.fc261774.jpg";